












 








const node = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "signOut",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "AtmosphereSignOutMutation",
    "selections": (v0/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "AtmosphereSignOutMutation",
    "selections": (v0/*:: as any*/)
  },
  "params": {
    "id": "m_v8yukQlxGn4893IQkkUGTA",
    "metadata": {},
    "name": "AtmosphereSignOutMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node ).hash = "1a6e3b5f6b663d648281322c374e4295";

export default node;
